/* SOLUM CLAVIS — « Call us » : concierge voix IA (toutes pages Pro)
   ─────────────────────────────────────────────────────────────────
   Chargé par snippets/sc-call.liquid (layouts theme + sc-v2, pros only).
   1. Remplace TOUS les boutons « Video Guide » morts (#scVideoExplainerBtnDash,
      button.video-guide, .sc-video-explainer__trigger.ve-pulse — sauf scVideoSO*
      qui a de vraies vidéos) par « Call us » (clone-replace : tue les anciens
      listeners).
   2. Appel voix : POST {api}/api/pro/call/session puis WebRTC DIRECT
      navigateur ↔ OpenAI Realtime. Tools exécutés ici (DOM live).
   3. Guidage : spotlight + fenêtre en pastille (scpc-docked). Sur l'onglet
      d'appel, tout lien surligné s'ouvre en NOUVEL onglet (une navigation
      tuerait le WebRTC).
   4. Continuité multi-onglets (BroadcastChannel "scpc-guide") : les autres
      pages Solum portent sc-call-agent.js ; le hub sait quels onglets sont
      ouverts, lit leur contenu (get_screen) et y surligne par libellé
      (highlight_on_screen). Ouvertures/focus/clics remontent en [ui-event]. */
(function () {
  "use strict";
  var cfg = document.getElementById("scCallCfg");
  if (!cfg) return;
  var D = cfg.dataset;
  // Mode PUBLIC (visiteur non connecté / client B2C) : pas de compte, endpoint
  // /api/public/call/session, tools guidage seuls, cap 10 min. Bande en bas de
  // page (#scpcPublicCall) au lieu du bouton header.
  var PUB = D.public === "1";
  if (!PUB && (!D.customerId || !D.email)) return;

  var CAP_MS = (PUB ? 10 : 20) * 60 * 1000;
  var pc = null, dc = null, mic = null, audioEl = null, ac = null;
  var ringOsc = null, ringGain = null, ringTimer = null;
  var timerIv = null, t0 = 0, muted = false, live = false, connecting = false;
  // tier RÉSOLU PAR LE SERVEUR au mint de session (jamais deviné côté front —
  // BUSINESS* = ultimate, ledger "pro" = select) ; le data-tier Liquid n'est
  // qu'une valeur d'attente avant le 1er appel
  var sessTier = (D.tier === "pro" || D.tier === "select") ? "select" : "ultimate";
  // Garde-fou coût (demande Marc 2026-08-16) : 8 s de silence TOTAL (ni le
  // client ni l'assistante) → coupure, il faut rappeler. Pendant un guidage
  // actif (spot affiché / clic récent), tolérance élargie à 25 s.
  var IDLE_MS = 8000, IDLE_GUIDE_MS = 25000;
  var lastAct = 0, lastGuide = 0, idleWarned = false;

  function $(id) { return document.getElementById(id); }
  var ov = $("scpcOverlay");
  if (!ov) return;

  var MYPAGE = (location.pathname.match(/\/pages\/([a-z0-9-]+)/) || [])[1] || "dashboard";

  function setState(s, msg) {
    ov.setAttribute("data-state", s);
    var st = $("scpcStatus");
    if (st) st.textContent = msg || "";
  }
  function send(o) {
    try { if (dc && dc.readyState === "open") dc.send(JSON.stringify(o)); } catch (e) {}
  }
  function pad(n) { return (n < 10 ? "0" : "") + n; }

  /* ── boutons « Video Guide » → « Call us », sur TOUTES les pages ───── */
  var PHONE_SVG = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>';
  var swappedAny = false;
  function swapButtons() {
    // tous les déclencheurs « Video Guide » du thème (send-funds/shipping/rates/
    // bulk/my-orders/dashboards JP-TH…) — les __close ne matchent pas, et le
    // guide Single Order (scVideoSO*, vraies vidéos) est exclu plus bas
    var btns = document.querySelectorAll('#scVideoExplainerBtnDash, button.video-guide, .sc-video-explainer__trigger');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.dataset.scpcDone || /^scVideoSO/.test(btn.id || "")) continue;
      var nb = btn.cloneNode(false); // sans enfants ni listeners
      nb.removeAttribute("onclick");
      nb.dataset.scpcDone = "1";
      nb.innerHTML = '<span class="ve-play-circle">' + PHONE_SVG + "</span> " + (D.lCall || "Call us");
      nb.addEventListener("click", function (e) { e.preventDefault(); openCall(); });
      btn.replaceWith(nb);
      swappedAny = true;
    }
  }
  // Pages Pro sans bouton Video Guide : lanceur flottant discret (bas-gauche)
  function removeLauncher() {
    var b = document.getElementById("scpcLaunch");
    if (b) b.remove();
  }
  function ensureLauncher() {
    if (PUB) return; // la bande publique sert de lanceur
    if (swappedAny || document.getElementById("scpcLaunch")) return;
    if (!/\/pages\/(pro-|wholesale|fresh)/.test(location.pathname)) return;
    var b = document.createElement("button");
    b.id = "scpcLaunch";
    b.type = "button";
    b.innerHTML = PHONE_SVG + "<span>" + (D.lCall || "Call us") + "</span>";
    b.addEventListener("click", openCall);
    document.body.appendChild(b);
  }

  /* ── inventaire générique des éléments cliquables (page courante) ──── */
  function labelOf(el) {
    var v = el.getAttribute("aria-label") || el.value || el.placeholder || el.innerText || "";
    return String(v).replace(/\s+/g, " ").trim().slice(0, 80);
  }
  function isVis(el) {
    if (el.offsetParent === null && getComputedStyle(el).position !== "fixed") return false;
    var r = el.getBoundingClientRect();
    return r.width > 8 && r.height > 8;
  }
  function scanEls() {
    var els = document.querySelectorAll('button, a[href], input:not([type="hidden"]), select, textarea, [role="button"]');
    var out = [], map = {};
    for (var i = 0; i < els.length && out.length < 80; i++) {
      if (!isVis(els[i])) continue;
      var lb = labelOf(els[i]);
      if (!lb || map[lb]) continue;
      map[lb] = els[i];
      out.push(lb);
    }
    return { labels: out, map: map };
  }
  function scanHeadings() {
    var hs = document.querySelectorAll("h1,h2,h3");
    var out = [];
    for (var i = 0; i < hs.length && out.length < 12; i++) {
      var t = (hs[i].innerText || "").replace(/\s+/g, " ").trim().slice(0, 90);
      if (t && isVis(hs[i])) out.push(t);
    }
    return out;
  }
  function findByLabel(q) {
    var s = scanEls(), keys = Object.keys(s.map), ql = String(q).toLowerCase();
    for (var i = 0; i < keys.length; i++) if (keys[i].toLowerCase() === ql) return { el: s.map[keys[i]], label: keys[i] };
    for (i = 0; i < keys.length; i++) if (keys[i].toLowerCase().indexOf(ql) !== -1) return { el: s.map[keys[i]], label: keys[i] };
    for (i = 0; i < keys.length; i++) if (ql.indexOf(keys[i].toLowerCase()) !== -1 && keys[i].length > 3) return { el: s.map[keys[i]], label: keys[i] };
    return null;
  }

  /* ── ancres soignées du dashboard ──────────────────────────────────── */
  var ANCHORS = {
    balance_cards: { sel: ".pd-stats-row", tab: "home" },
    fx_rate_card: { sel: "#pdOvRateCard", tab: "home" },
    search_bar: { sel: "#scusWrap,#scusInput", tab: "home" },
    send_funds: { sel: 'a.pd-action-card[href*="pro-send-funds"]', tab: "home", nav: 1 },
    single_order: { sel: ".pd-actions-row .pd-action-card:nth-child(2)", tab: "order" },
    bulk_order: { sel: 'a.pd-action-card[href*="pro-bulk-order"]', tab: "order", nav: 1 },
    order_sheet: { sel: ".pd-actions-row .pd-action-card:nth-child(4)", tab: "order" },
    my_orders: { sel: ".pd-tm-orders", tab: "order", nav: 1 },
    shipping: { sel: 'a[href*="/pages/pro-shipping"]', tab: "order", nav: 1 },
    pro_rates: { sel: 'a[href*="/pages/pro-rates"]', tab: "market", nav: 1 },
    in_stock_now: { sel: 'a[href*="/pages/pro-instock"]', tab: "order", nav: 1 },
    wholesale: { sel: 'a[href*="/pages/wholesale"],a[href*="pro-wholesale"]', tab: "market", nav: 1 },
    food_market: { sel: 'a[href*="/pages/pro-food"]', tab: "market", nav: 1 },
    le_gourmet: { sel: 'a[href*="gourmet"]', tab: "market", nav: 1 },
    pharmacy: { sel: 'a[href*="pro-pharmacy"]', tab: "market", nav: 1 },
    pre_owned: { sel: 'a[href*="pro-pre-owned"]', tab: "market", nav: 1 },
    partner_api: { sel: ".pa-dev", tab: "account" },
    customs_documents: { sel: "#pdCxCard", tab: "account" },
    community_board: { sel: 'a[href*="pro-board"]', tab: "account", nav: 1 },
    business_stats: { sel: "#scanCard", tab: "market" }
  };

  var spotEl = null, spotTarget = null, spotRaf = 0, spotClickH = null;
  var spotSetAt = 0, spotStaleAt = 0;

  function findVisible(selList) {
    var sels = selList.split(",");
    for (var s = 0; s < sels.length; s++) {
      var els = document.querySelectorAll(sels[s].trim());
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (els[i].offsetParent !== null && r.width > 4 && r.height > 4) return els[i];
      }
    }
    return null;
  }
  function ensureSpot() {
    if (spotEl) return spotEl;
    spotEl = document.createElement("div");
    spotEl.id = "scpcSpot";
    spotEl.innerHTML = '<span class="scpc-spot-hint"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11.3V4.5a1.5 1.5 0 0 1 3 0v5.8"/><path d="M12 10.3v-1a1.5 1.5 0 0 1 3 0v2"/><path d="M15 11.3v-.5a1.5 1.5 0 0 1 3 0v3.2a6 6 0 0 1-6 6h-1.6a6 6 0 0 1-4.7-2.3l-2.5-3.1a1.4 1.4 0 0 1 2-1.9l1.8 1.4V6.9"/></svg></span>';
    document.body.appendChild(spotEl);
    return spotEl;
  }
  function positionSpot() {
    if (!spotTarget || !spotEl) return;
    // l'interface a bougé (chat qui avance, panneau re-rendu) → l'élément
    // surligné peut disparaître : auto-nettoyage + signal à l'assistante,
    // sinon le cadre reste bloqué dans le vide (vu par Marc sur le chat)
    var gone = !spotTarget.isConnected ||
      (spotTarget.offsetParent === null && getComputedStyle(spotTarget).position !== "fixed");
    if (gone) {
      if (!spotStaleAt) spotStaleAt = Date.now();
      else if (Date.now() - spotStaleAt > 1200) {
        clearSpot();
        if (live) uiEvent("The highlighted element just disappeared — the interface moved on (e.g. the chat advanced). Re-check with get_screen and keep guiding.");
        return;
      }
    } else {
      spotStaleAt = 0;
      var r = spotTarget.getBoundingClientRect();
      spotEl.style.left = (r.left - 7) + "px";
      spotEl.style.top = (r.top - 7) + "px";
      spotEl.style.width = (r.width + 14) + "px";
      spotEl.style.height = (r.height + 14) + "px";
    }
    spotRaf = requestAnimationFrame(positionSpot);
  }
  function clearSpot() {
    if (spotRaf) { cancelAnimationFrame(spotRaf); spotRaf = 0; }
    if (spotClickH && spotTarget) spotTarget.removeEventListener("click", spotClickH, true);
    spotClickH = null;
    spotTarget = null;
    if (spotEl) { spotEl.remove(); spotEl = null; }
  }
  function dock(on) { ov.classList.toggle("scpc-docked", !!on); }

  function uiEvent(text) {
    lastAct = Date.now();
    lastGuide = Date.now();
    send({
      type: "conversation.item.create",
      item: { type: "message", role: "user", content: [{ type: "input_text", text: "[ui-event] " + text }] }
    });
    send({ type: "response.create" });
  }

  // Spotlight local sur un élément donné. L'onglet d'appel ne doit JAMAIS
  // naviguer (WebRTC) : tout lien surligné s'ouvre en nouvel onglet.
  function spotOn(el, clickedLabel) {
    lastGuide = Date.now();
    clearSpot();
    spotSetAt = Date.now();
    spotStaleAt = 0;
    spotTarget = el;
    ensureSpot();
    dock(true);
    try { el.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) { el.scrollIntoView(); }
    positionSpot();
    spotClickH = function (ev) {
      var link = el.closest ? (el.closest("a") || null) : null;
      var href = (link && link.href) || "";
      if (href && href.indexOf("javascript:") !== 0 && !(link.target === "_blank")) {
        ev.preventDefault();
        ev.stopPropagation();
        window.open(href, "_blank");
      }
      clearSpot();
      uiEvent('The caller just clicked "' + clickedLabel + '" — acknowledge and continue guiding.');
    };
    el.addEventListener("click", spotClickH, true);
  }

  function doHighlight(anchor) {
    var a = ANCHORS[anchor];
    if (!a) return { ok: false, error: "unknown_anchor" };
    clearSpot();
    if (document.body.classList.contains("scm-on") && a.tab) {
      var tabBtn = document.querySelector('.scm-tab[data-tab="' + a.tab + '"]');
      if (tabBtn) tabBtn.click();
    }
    var el = findVisible(a.sel);
    if (!el) return { ok: true, visible: false, note: "element not visible on this screen — describe the path in words instead" };
    spotOn(el, anchor);
    return { ok: true, visible: true, navigates: !!a.nav };
  }

  /* ── continuité multi-onglets (hub BroadcastChannel) ───────────────── */
  var bc = (typeof BroadcastChannel !== "undefined") ? new BroadcastChannel("scpc-guide") : null;
  var tabs = {}, pending = {}, cmdSeq = 0, lastFocus = null;
  var evThrottle = {};
  function throttled(key, ms) {
    var now = Date.now();
    if (evThrottle[key] && now - evThrottle[key] < ms) return true;
    evThrottle[key] = now;
    return false;
  }
  if (bc) bc.onmessage = function (e) {
    var msg = e.data || {};
    if (!msg.t || msg.page === MYPAGE) return; // ignorer notre propre onglet
    if (msg.t === "hello") {
      var isNew = !tabs[msg.page];
      tabs[msg.page] = { title: msg.title || "", seen: Date.now() };
      if (msg.focused) lastFocus = msg.page;
      if (live && isNew && !throttled("hello:" + msg.page, 15000))
        uiEvent('The caller opened the Solum page "' + msg.page + '" in another tab' + (msg.title ? ' ("' + msg.title + '")' : "") + ". Use get_screen to see it and keep guiding.");
    } else if (msg.t === "focus") {
      if (tabs[msg.page]) tabs[msg.page].seen = Date.now();
      var changed = lastFocus !== msg.page;
      lastFocus = msg.page;
      if (live && changed && !throttled("focus", 8000))
        uiEvent('The caller switched to the tab "' + msg.page + '".');
    } else if (msg.t === "bye") {
      delete tabs[msg.page];
      if (lastFocus === msg.page) lastFocus = null;
    } else if (msg.t === "click") {
      if (live) uiEvent('The caller just clicked "' + (msg.label || "") + '" on the page "' + msg.page + '". Acknowledge and continue guiding.');
    } else if (msg.t === "gone") {
      if (live) uiEvent('The highlighted element on the page "' + msg.page + '" disappeared — the interface moved on. Re-check with get_screen and keep guiding.');
    } else if (msg.t === "chatadv") {
      if (live && !throttled("chatadv", 4000)) {
        lastGuide = Date.now();
        uiEvent('The chat on the page "' + msg.page + '" advanced — ' + (msg.step ? msg.step + " · " : "") + 'latest: "' + (msg.latest || "") + '"' + (msg.buttons ? " · buttons: " + msg.buttons : "") + ". Briefly confirm and tell the caller what to do next.");
      }
    } else if (msg.t === "res" && pending[msg.id]) {
      pending[msg.id](msg);
      delete pending[msg.id];
    }
  };
  window.addEventListener("focus", function () { lastFocus = null; });
  function cmd(page, action, extra) {
    return new Promise(function (resolve) {
      if (!bc || !tabs[page]) return resolve({ ok: false, error: "page_not_open", note: "this page is not connected — maybe still loading, or already closed" });
      var id = "c" + (++cmdSeq);
      pending[id] = resolve;
      var o = { t: "cmd", id: id, page: page, action: action };
      for (var k in (extra || {})) o[k] = extra[k];
      bc.postMessage(o);
      setTimeout(function () {
        if (pending[id]) { pending[id]({ ok: false, error: "no_response" }); delete pending[id]; }
      }, 900);
    });
  }
  function chatRead() {
    var bubbles = document.querySelectorAll(".sc-bubble");
    if (!bubbles.length) return null;
    var msgs = [];
    for (var i = Math.max(0, bubbles.length - 6); i < bubbles.length; i++) {
      var t = (bubbles[i].innerText || "").replace(/\s+/g, " ").trim().slice(0, 140);
      if (t) msgs.push(t);
    }
    var acts = [];
    var ab = document.querySelectorAll(".sc-action");
    for (var j = 0; j < ab.length && acts.length < 8; j++) {
      if (!isVis(ab[j])) continue;
      var at = (ab[j].innerText || "").replace(/\s+/g, " ").trim().slice(0, 60);
      if (at) acts.push(at);
    }
    var st = document.querySelector(".sc-progress__label");
    return {
      step: st ? (st.innerText || "").replace(/\s+/g, " ").trim() : "",
      last_messages: msgs,
      quick_buttons: acts
    };
  }

  /* ── Le TEXTE de la page ────────────────────────────────────────────────
     Sans lui l'assistante « voit » une fiche produit sans pouvoir la lire :
     le prix, l'état, la matière, les dimensions, les notes d'état ne sont ni
     des titres ni des éléments cliquables (signalé par Marc le 2026-08-21 sur
     /pages/piece — elle connaissait le nom de la pièce et rien d'autre).
     Générique, aucun sélecteur par page : on parcourt le contenu principal
     bloc par bloc en sautant le chrome. innerText suit la mise en page réelle,
     donc ni les panneaux repliés ni l'autre langue ne remontent. */
  var PAGE_TEXT_MAX = 2200;
  function readBlocks(root, limit) {
    var SKIP_TAG = /^(SCRIPT|STYLE|NOSCRIPT|HEADER|FOOTER|NAV|TEMPLATE)$/;
    var SKIP_ID = /^(scpcOverlay|scpcSpot|scCallCfg|peuCartDrawer)$/;
    var SKIP_CLS = /scpc-band|po-cart-drawer|sc-call/;
    var kids = root.children && root.children.length ? root.children : [root];
    var out = [], n = 0;
    for (var i = 0; i < kids.length && n < limit; i++) {
      var el = kids[i];
      if (SKIP_TAG.test(el.tagName) || SKIP_ID.test(el.id || "")) continue;
      if (SKIP_CLS.test(String(el.className || ""))) continue;
      if (!isVis(el)) continue;
      var t = (el.innerText || "").replace(/[ \t]+/g, " ").replace(/\n{2,}/g, "\n").trim();
      if (!t) continue;
      out.push(t); n += t.length;
    }
    return out.join("\n");
  }
  function pageText() {
    var m = document.querySelector("main, [role=main], #MainContent");
    var s = m ? readBlocks(m, PAGE_TEXT_MAX) : "";
    if (s.length < 40) s = readBlocks(document.body, PAGE_TEXT_MAX);
    return s.length > PAGE_TEXT_MAX ? s.slice(0, PAGE_TEXT_MAX) + " \u2026" : s;
  }

  function localRead() {
    var s = scanEls();
    var out = {
      ok: true,
      title: document.title.replace(/\s+/g, " ").trim().slice(0, 120),
      headings: scanHeadings(),
      elements: s.labels
    };
    var ct = pageText();
    if (ct) out.content = ct;
    var ch = chatRead();
    if (ch) out.chat = ch;
    return out;
  }
  function focusedPage(argPage) {
    if (argPage) return argPage;
    if (document.hasFocus() || !lastFocus) return MYPAGE;
    return lastFocus;
  }

  /* ── tools ─────────────────────────────────────────────────────────── */
  function txt(id) {
    var el = document.getElementById(id);
    var v = el && el.textContent ? el.textContent.replace(/\s+/g, " ").trim() : "";
    return (!v || v === "—" || v === "…") ? "not loaded yet" : v;
  }
  var TOOLS = {
    get_dashboard_snapshot: function () {
      return {
        effective_balance: txt("pdOvEffBal"),
        available_balance: txt("pdOvAvailBal"),
        last_topup: txt("pdOvLastTopup"),
        pending: txt("pdOvPending"),
        pending_count: txt("pdOvPendingCount"),
        active_orders: txt("pdOvActiveOrders"),
        active_orders_detail: txt("pdOvActiveDetail"),
        eur_krw_rate: txt("pdOvRateMain"),
        rate_updated: txt("pdOvRateTime"),
        note: MYPAGE === "dashboard" || MYPAGE === "pro-concierge" ? "" : "the call is not on the dashboard page — values may be empty; the caller is on " + MYPAGE
      };
    },
    get_recent_orders: function () {
      var out = [];
      var rows = document.querySelectorAll("#pdTmOrdersList .pd-tm-orow");
      for (var i = 0; i < rows.length && out.length < 15; i++) {
        if (rows[i].querySelector(".pd-tm-skel")) continue;
        var t = (rows[i].innerText || "").replace(/\s+/g, " ").trim();
        if (t) out.push(t);
      }
      var tag = document.getElementById("pdTmOrdersTag");
      return {
        orders: out,
        summary: tag ? tag.textContent.replace(/\s+/g, " ").trim() : "",
        note: out.length ? "" : "list not loaded here — the full history is on the My Orders page"
      };
    },
    highlight_anchor: function (args) {
      return doHighlight(String((args && args.anchor) || ""));
    },
    clear_highlight: function () {
      clearSpot();
      dock(false);
      if (bc) bc.postMessage({ t: "clearall", page: MYPAGE });
      return { ok: true };
    },
    get_screen: function (args) {
      if (bc) bc.postMessage({ t: "ping", page: MYPAGE });
      return new Promise(function (resolve) {
        setTimeout(function () {
          var now = Date.now();
          var pages = [{ page: MYPAGE, title: document.title.slice(0, 90), call_tab: true }];
          for (var p in tabs) if (now - tabs[p].seen < 15000) pages.push({ page: p, title: tabs[p].title.slice(0, 90) });
          var target = focusedPage(args && args.page);
          if (target === MYPAGE) {
            var r = localRead();
            resolve({ pages: pages, focused: target, title: r.title, headings: r.headings, content: r.content || "", elements: r.elements });
          } else {
            cmd(target, "read").then(function (r) {
              resolve({ pages: pages, focused: target, ok: r.ok, title: r.title, headings: r.headings, content: r.content || "", elements: r.elements, note: r.note || r.error });
            });
          }
        }, 400);
      });
    },
    highlight_on_screen: function (args) {
      var label = String((args && args.label) || "");
      var target = focusedPage(args && args.page);
      if (target === MYPAGE) {
        var hit = findByLabel(label);
        if (!hit) return { found: false, note: "no visible element matching this label on " + MYPAGE + " — check with get_screen" };
        spotOn(hit.el, hit.label);
        return { found: true, label: hit.label, page: MYPAGE };
      }
      dock(true);
      lastGuide = Date.now();
      return cmd(target, "highlight", { label: label }).then(function (r) {
        return r.ok ? r.result : { found: false, note: r.note || r.error };
      });
    },
    get_brand_rate: function (args) {
      var q = normBrand((args && args.brand) || "");
      if (!q) return { found: false, error: "brand_required" };
      return fetchRates().then(function (j) {
        if (!j || !j.rates) return { found: false, note: "rates unavailable right now — the team can confirm by KakaoTalk" };
        var m = matchBrand(q, j.rates.reduce(function (acc, g) {
          g.brands.forEach(function (b) { acc.push({ b: b, pct: g.pct }); });
          return acc;
        }, []));
        if (!m) {
          var no = matchBrand(q, (j.notOffered || []).map(function (b) { return { b: b, pct: 0 }; }));
          if (no) return { found: true, offered: false, brand: no.b.n, note: "Solum does not offer this brand" };
          return { found: false, note: "no negotiated rate on file for this brand — offer to send a request to the sourcing team (request_brand_quote)" };
        }
        var ultimate = sessTier !== "select";
        var your = ultimate ? m.pct : Math.max(0, m.pct - 2);
        return {
          found: true, offered: true,
          brand: m.b.n, brand_ko: m.b.k || "", official_site: m.b.d || "",
          your_discount_pct: your,
          tier_note: ultimate ? "Ultimate rate" : "Select rate (Ultimate " + m.pct + "% minus 2 points)",
          base: "discount on the brand's official-site price",
          rates_updated: j.updateDate || "", valid_until: j.validUntil || ""
        };
      });
    },
    request_brand_quote: function (args) {
      var brand = String((args && args.brand) || "").trim();
      if (brand.length < 2) return { ok: false, error: "brand_required" };
      return fetch(D.api + "/api/pro/call/brand-request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerId: D.customerId, email: D.email, lang: D.lang,
          brand: brand, note: String((args && args.note) || "").slice(0, 300)
        })
      }).then(function (r) { return r.json(); }).then(function (j) {
        return j.ok ? { ok: true, note: "request sent — the team will reply by KakaoTalk or email" }
                    : { ok: false, note: "could not send right now — invite the caller to write to hello@solumclavis.com" };
      }).catch(function () {
        return { ok: false, note: "could not send right now — invite the caller to write to hello@solumclavis.com" };
      });
    }
  };

  /* ── taux par marque (PRO_RATES, servi par /api/pro/rates) ─────────── */
  var ratesCache = null;
  function fetchRates() {
    if (ratesCache) return Promise.resolve(ratesCache);
    return fetch(D.api + "/api/pro/rates").then(function (r) { return r.json(); })
      .then(function (j) { ratesCache = j; return j; })
      .catch(function () { return null; });
  }
  function normBrand(s) {
    try { s = String(s).normalize("NFD").replace(/[̀-ͯ]/g, ""); } catch (e) {}
    return String(s).toLowerCase().trim();
  }
  function matchBrand(q, entries) {
    for (var pass = 0; pass < 2; pass++) {
      for (var i = 0; i < entries.length; i++) {
        var b = entries[i].b;
        var names = [b.n, b.k, b.j, (b.d || "").replace(/\.[a-z.]+$/, "")];
        for (var n = 0; n < names.length; n++) {
          var nn = normBrand(names[n] || "");
          if (!nn) continue;
          if (pass === 0 && nn === q) return entries[i];
          if (pass === 1 && nn.length > 2 && (nn.indexOf(q) !== -1 || q.indexOf(nn) !== -1)) return entries[i];
        }
      }
    }
    return null;
  }

  if (PUB) {
    delete TOOLS.get_dashboard_snapshot;
    delete TOOLS.get_recent_orders;
    delete TOOLS.highlight_anchor;
    delete TOOLS.get_brand_rate;
    delete TOOLS.request_brand_quote;
  }

  function onEvent(e) {
    var ev;
    try { ev = JSON.parse(e.data); } catch (err) { return; }
    if (ev.type === "response.done" && ev.response && ev.response.output) {
      for (var i = 0; i < ev.response.output.length; i++) {
        var item = ev.response.output[i];
        if (item.type === "function_call") runTool(item);
      }
    }
  }
  function runTool(item) {
    var out, args = {};
    try { args = JSON.parse(item.arguments || "{}"); } catch (e) {}
    try { out = TOOLS[item.name] ? TOOLS[item.name](args) : { error: "unknown_tool" }; }
    catch (err) { out = { error: String(err && err.message) }; }
    Promise.resolve(out).then(function (o) {
      send({ type: "conversation.item.create", item: { type: "function_call_output", call_id: item.call_id, output: JSON.stringify(o) } });
      send({ type: "response.create" });
    });
  }

  /* ── tonalité d'appel (425 Hz, cadence européenne) ─────────────────── */
  function audioCtx() {
    if (!ac) ac = new (window.AudioContext || window.webkitAudioContext)();
    if (ac.state === "suspended") ac.resume();
    return ac;
  }
  function startRing() {
    try {
      var a = audioCtx();
      ringGain = a.createGain(); ringGain.gain.value = 0; ringGain.connect(a.destination);
      ringOsc = a.createOscillator(); ringOsc.frequency.value = 425;
      ringOsc.connect(ringGain); ringOsc.start();
      var on = false;
      (function cycle() {
        on = !on;
        ringGain.gain.setTargetAtTime(on ? 0.045 : 0, a.currentTime, 0.02);
        ringTimer = setTimeout(cycle, on ? 1500 : 3500);
      })();
    } catch (e) {}
  }
  function stopRing() {
    if (ringTimer) { clearTimeout(ringTimer); ringTimer = null; }
    try { if (ringOsc) ringOsc.stop(); } catch (e) {}
    ringOsc = null;
    try { if (ringGain) ringGain.disconnect(); } catch (e) {}
    ringGain = null;
  }

  /* ── vumètre ───────────────────────────────────────────────────────── */
  function attachMeter(stream) {
    try {
      var a = audioCtx();
      var src = a.createMediaStreamSource(stream);
      var an = a.createAnalyser(); an.fftSize = 256;
      src.connect(an);
      var data = new Uint8Array(an.frequencyBinCount);
      var av = $("scpcAvatar");
      (function loop() {
        if (!pc) return; // ontrack arrive AVANT live=true : boucler tant que la connexion existe
        an.getByteFrequencyData(data);
        var s = 0;
        for (var i = 0; i < data.length; i++) s += data[i];
        var avg = s / data.length;
        if (avg > 8) lastAct = Date.now();
        if (av) av.style.setProperty("--lvl", Math.min(1, avg / 80).toFixed(2));
        requestAnimationFrame(loop);
      })();
    } catch (e) {}
  }

  function attachMicMeter(stream) {
    try {
      var a = audioCtx();
      var src = a.createMediaStreamSource(stream);
      var an = a.createAnalyser(); an.fftSize = 256;
      src.connect(an);
      var data = new Uint8Array(an.frequencyBinCount);
      var floor = 999; // plancher de bruit adaptatif : suit le niveau ambiant
      (function loop() {
        if (!live) return;
        an.getByteFrequencyData(data);
        var s = 0;
        for (var i = 0; i < data.length; i++) s += data[i];
        var avg = s / data.length;
        if (avg < floor) floor = avg; else floor += 0.02;
        if (avg > floor + 12 && avg > 14) lastAct = Date.now();
        requestAnimationFrame(loop);
      })();
    } catch (e) {}
  }
  function warnBeep() {
    try {
      var a = audioCtx();
      var g = a.createGain(); g.gain.value = 0; g.connect(a.destination);
      var o = a.createOscillator(); o.frequency.value = 880; o.connect(g); o.start();
      g.gain.setTargetAtTime(0.05, a.currentTime, 0.01);
      g.gain.setTargetAtTime(0, a.currentTime + 0.12, 0.02);
      g.gain.setTargetAtTime(0.05, a.currentTime + 0.3, 0.01);
      g.gain.setTargetAtTime(0, a.currentTime + 0.42, 0.02);
      setTimeout(function () { try { o.stop(); g.disconnect(); } catch (e) {} }, 700);
    } catch (e) {}
  }

  /* ── cycle d'appel ─────────────────────────────────────────────────── */
  function openCall() {
    var st = ov.getAttribute("data-state");
    if (st === "live" || st === "connecting") { ov.hidden = false; return; }
    ov.hidden = false;
    connecting = true; muted = false; live = false;
    var mu = $("scpcMuteLbl"); if (mu) mu.textContent = D.lMute || "Mute";
    var tm = $("scpcTimer"); if (tm) tm.textContent = "00:00";
    setState("connecting", D.lConnecting || "Connecting…");
    startRing();
    navigator.mediaDevices.getUserMedia({ audio: true }).then(function (ms) {
      if (!connecting) { ms.getTracks().forEach(function (t) { t.stop(); }); return null; }
      mic = ms;
      return fetch(D.api + (PUB ? "/api/public/call/session" : "/api/pro/call/session"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(PUB ? { lang: D.lang, market: D.market, page: MYPAGE } : {
          customerId: D.customerId, email: D.email, lang: D.lang,
          tier: D.tier, market: D.market, company: D.company || ""
        })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
      });
    }).then(function (res) {
      if (!res || !connecting) return null;
      if (!res.ok || !res.j.ok) {
        var err = new Error((res.j && res.j.message) || D.lFailed || "Call failed");
        err.scpcServer = true;
        throw err;
      }
      if (res.j.tier) sessTier = res.j.tier;
      return connectRtc(res.j.clientSecret, res.j.model);
    }).catch(function (e) {
      stopRing();
      connecting = false;
      cleanupRtc();
      if (e && e.name === "NotAllowedError") setState("error", D.lMicdenied || "Microphone access is needed.");
      else setState("error", (e && e.scpcServer && e.message) || D.lFailed || "Call failed");
    });
  }

  function connectRtc(secret, model) {
    pc = new RTCPeerConnection();
    mic.getAudioTracks().forEach(function (t) { pc.addTrack(t, mic); });
    audioEl = new Audio(); audioEl.autoplay = true;
    pc.ontrack = function (e) {
      audioEl.srcObject = e.streams[0];
      var p = audioEl.play(); if (p && p.catch) p.catch(function () {});
      attachMeter(e.streams[0]);
    };
    dc = pc.createDataChannel("oai-events");
    dc.onmessage = onEvent;
    dc.onopen = function () {
      connecting = false; live = true;
      stopRing();
      lastAct = Date.now(); idleWarned = false;
      if (mic) attachMicMeter(mic);
      setState("live", D.lOncall || "On call");
      t0 = Date.now();
      timerIv = setInterval(tick, 500);
      if (bc) bc.postMessage({ t: "ping", page: MYPAGE }); // recenser les onglets déjà ouverts
      var ctxNote = (MYPAGE !== "dashboard" && MYPAGE !== "pro-concierge")
        ? '[ui-event] Note: this call starts from the Solum page "' + MYPAGE + '", not the dashboard. Use get_screen to see it.' : "";
      if (ctxNote) send({ type: "conversation.item.create", item: { type: "message", role: "user", content: [{ type: "input_text", text: ctxNote }] } });
      send({ type: "response.create" }); // l'assistante décroche et salue
    };
    pc.onconnectionstatechange = function () {
      if (pc && (pc.connectionState === "failed" || pc.connectionState === "disconnected") && live) endCall();
    };
    return pc.createOffer().then(function (offer) {
      return pc.setLocalDescription(offer).then(function () {
        return fetch("https://api.openai.com/v1/realtime/calls?model=" + encodeURIComponent(model || ""), {
          method: "POST",
          headers: { Authorization: "Bearer " + secret, "Content-Type": "application/sdp" },
          body: offer.sdp
        });
      });
    }).then(function (r) {
      if (!r.ok) {
        // ancien endpoint en secours
        return fetch("https://api.openai.com/v1/realtime?model=" + encodeURIComponent(model || ""), {
          method: "POST",
          headers: { Authorization: "Bearer " + secret, "Content-Type": "application/sdp" },
          body: pc.localDescription.sdp
        }).then(function (r2) {
          if (!r2.ok) throw new Error(D.lFailed || "Call failed");
          return r2.text();
        });
      }
      return r.text();
    }).then(function (answer) {
      return pc.setRemoteDescription({ type: "answer", sdp: answer });
    });
  }

  function tick() {
    var tm = $("scpcTimer");
    var s = Math.floor((Date.now() - t0) / 1000);
    if (tm) tm.textContent = pad(Math.floor(s / 60)) + ":" + pad(s % 60);
    if (Date.now() - t0 > CAP_MS) { endCall(); return; }
    var guiding = (spotEl && Date.now() - spotSetAt < 60000) || (Date.now() - lastGuide < 30000);
    var limit = guiding ? IDLE_GUIDE_MS : IDLE_MS;
    var idle = Date.now() - lastAct;
    if (idle > limit) { endCall("idle"); return; }
    if (idle > limit - 2000) { if (!idleWarned) { idleWarned = true; warnBeep(); } }
    else idleWarned = false;
  }

  function cleanupRtc() {
    try { if (dc) dc.close(); } catch (e) {}
    dc = null;
    try { if (pc) pc.close(); } catch (e) {}
    pc = null;
    if (mic) { mic.getTracks().forEach(function (t) { t.stop(); }); mic = null; }
    if (audioEl) { try { audioEl.pause(); audioEl.srcObject = null; } catch (e) {} audioEl = null; }
  }

  function endCall(reason) {
    if (timerIv) { clearInterval(timerIv); timerIv = null; }
    stopRing();
    connecting = false; live = false;
    cleanupRtc();
    clearSpot();
    dock(false);
    if (bc) bc.postMessage({ t: "clearall", page: MYPAGE });
    var tm = $("scpcTimer");
    var dur = tm && tm.textContent !== "00:00" ? " · " + tm.textContent : "";
    var lbl = reason === "idle" ? (D.lIdle || D.lEnded || "Call ended") : (D.lEnded || "Call ended");
    setState("ended", lbl + dur);
  }

  function bindOverlay() {
    var end = $("scpcEnd"), close = $("scpcClose"), retry = $("scpcRetry"),
        mute = $("scpcMute"), back = $("scpcBackdrop"), av = $("scpcAvatar");
    if (end) end.addEventListener("click", endCall);
    if (retry) retry.addEventListener("click", function () { setState("idle", ""); openCall(); });
    if (close) close.addEventListener("click", function () {
      if (live || connecting) endCall();
      ov.hidden = true;
      setState("idle", "");
    });
    if (back) back.addEventListener("click", function () {
      if (!live && !connecting) { ov.hidden = true; setState("idle", ""); }
    });
    if (mute) mute.addEventListener("click", function () {
      if (!mic) return;
      muted = !muted;
      mic.getAudioTracks().forEach(function (t) { t.enabled = !muted; });
      mute.classList.toggle("is-muted", muted);
      var lbl = $("scpcMuteLbl");
      if (lbl) lbl.textContent = muted ? (D.lUnmute || "Unmute") : (D.lMute || "Mute");
    });
    if (av) av.addEventListener("click", function () {
      if (live) ov.classList.toggle("scpc-docked");
    });
    window.addEventListener("beforeunload", function () { if (live || connecting) cleanupRtc(); });
  }

  // Suivi du chat concierge pendant l'appel : à chaque nouvelle bulle/étape,
  // prévenir l'assistante pour qu'elle accompagne (« parfait — maintenant
  // choisissez l'adresse… »). Le chat actif compte aussi comme guidage
  // (pas de coupure silence pendant que le pro remplit le chat).
  var _chatSig = "", _chatT = 0, _chatLastEv = 0;
  new MutationObserver(function () {
    if (_chatT) return;
    _chatT = setTimeout(function () {
      _chatT = 0;
      if (!live) return;
      var ch = chatRead();
      if (!ch) return;
      var sig = ch.step + "|" + (ch.last_messages[ch.last_messages.length - 1] || "") + "|" + ch.quick_buttons.join(",");
      if (sig === _chatSig) return;
      _chatSig = sig;
      lastGuide = Date.now();
      if (Date.now() - _chatLastEv < 4000) return;
      _chatLastEv = Date.now();
      uiEvent("The on-page chat advanced — " + (ch.step ? ch.step + " · " : "") +
        'latest message: "' + (ch.last_messages[ch.last_messages.length - 1] || "") + '"' +
        (ch.quick_buttons.length ? " · buttons: " + ch.quick_buttons.join(" / ") : "") +
        ". Briefly confirm and tell the caller what to do next.");
    }, 1000);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // hook de debug / réutilisation (tests E2E)
  window.__scpc = {
    send: send,
    highlight: doHighlight,
    screen: function (a) { return TOOLS.get_screen(a || {}); },
    spotlabel: function (a) { return TOOLS.highlight_on_screen(a || {}); },
    clear: function () { clearSpot(); dock(false); },
    state: function () { return ov.getAttribute("data-state"); },
    tabs: function () { return Object.keys(tabs); },
    stream: function () { return audioEl && audioEl.srcObject; },
    idleMs: function () { return lastAct ? Date.now() - lastAct : -1; }
  };

  function init() {
    swapButtons();
    bindOverlay();
    var pb = document.getElementById("scpcPublicCall");
    if (pb) pb.addEventListener("click", openCall);
    // certaines pages (ex. send-funds) rendent leur bouton Video Guide en JS,
    // bien apres le chargement : observer le DOM et remplacer des qu'il apparait
    var moT = 0;
    var mo = new MutationObserver(function () {
      if (moT) return;
      moT = setTimeout(function () {
        moT = 0;
        swapButtons();
        if (swappedAny) removeLauncher();
      }, 300);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  setTimeout(ensureLauncher, 4000); // lanceur seulement si aucun bouton n'est apparu
})();
